import { Link } from "react-router-dom";
import { Heart, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { useCart } from "../context/CartContext";
import { formatBRL, installmentText, discountPercent } from "../lib/format";

const ProductCard = ({ product }) => {
  const { addToCart, toggleFavorite, isFavorite } = useCart();
  const fav = isFavorite(product.id);
  const hasDiscount = product.oldPrice && product.oldPrice > product.price;

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col bg-white border border-slate-200 rounded-lg overflow-hidden hover:border-slate-300 hover:shadow-md transition-all duration-200"
    >
      <button
        onClick={() => toggleFavorite(product.id)}
        data-testid={`favorite-button-${product.id}`}
        aria-label="Favoritar"
        className="absolute top-2 right-2 z-10 h-9 w-9 rounded-full bg-white/90 border border-slate-200 flex items-center justify-center hover:bg-white transition-colors"
      >
        <Heart className={`h-4 w-4 ${fav ? "fill-brand text-brand" : "text-slate-500"}`} />
      </button>

      {hasDiscount && (
        <span className="absolute top-2 left-2 z-10 bg-brand text-white text-xs font-bold px-2 py-1 rounded">
          -{discountPercent(product.oldPrice, product.price)}%
        </span>
      )}

      <Link to={`/produto/${product.slug}`} className="block p-4">
        <div className="aspect-square bg-slate-50 rounded-md overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      </Link>

      <div className="flex flex-col flex-1 px-4 pb-4">
        <span className="text-xs font-medium uppercase tracking-wide text-slate-400">
          {product.category}
        </span>
        <Link to={`/produto/${product.slug}`}>
          <h3 
            className="mt-1 text-sm font-semibold text-slate-900 leading-snug line-clamp-2 min-h-[2.5rem] hover:text-brand transition-colors"
            dangerouslySetInnerHTML={{ __html: product.name }}
          >
          </h3>
        </Link>

        <div className="mt-3">
          {hasDiscount && (
            <span className="block text-xs text-slate-400 line-through">
              {formatBRL(product.oldPrice)}
            </span>
          )}
          <span className="block text-xl font-extrabold text-slate-900 tracking-tight">
            {formatBRL(product.price)}
          </span>
          <span className="block text-xs text-slate-500 mt-0.5">
            {installmentText(product.price)}
          </span>
        </div>

        <Button
          data-testid={`add-to-cart-${product.id}`}
          onClick={() => {
            addToCart(product);
            toast.success("Produto adicionado ao carrinho");
          }}
          className="mt-4 w-full h-11 bg-brand hover:bg-brand-hover text-white font-semibold rounded-md active:scale-[0.98] transition-all"
        >
          <ShoppingCart className="h-4 w-4 mr-2" /> Adicionar
        </Button>
      </div>
    </div>
  );
};

export default ProductCard;
